/** 批量新增转化的应用列表KEY */
module.exports = () => {
  return [
    { name: '广告主ID', value: 'advertiser_id', overflow: false, align: 'center' },
    { name: '应用ID', value: 'type_id', overflow: false, align: 'center' },
    { name: '应用名称', value: 'promoted_object_name', overflow: false, align: 'center' },
  ];
};
